import { LIVENESS_FAILED } from 'common/constants';
import { SendEventDisbursement, sendException } from 'helpers/analytics';
import { getChannelContextCode } from 'helpers/Utility';
import { setError } from 'store/actions/auth';
import { loading } from 'store/actions/loanApply';

export const handleErrorPassiveLivenessV3 = (
  dispatch,
  getState,
  err,
  param
) => {
  if (err.code === 'ERR_CANCELED') return;

  if (!err.response || err.code === 'ERR_NETWORK') {
    dispatch(setError('connection'));
    param?.verif && dispatch(loading(false));
    return;
  }

  const channelCode = getChannelContextCode(err, 'channel-context');

  const errorMap = {
    null: { key: 'privysys_fail', action: 'Unexpected Error Liveness' },
    211153: { key: LIVENESS_FAILED, action: 'Liveness Failed' },
    1039: { key: LIVENESS_FAILED, action: 'Liveness Failed' },
    1007: { key: 'vida_failed', action: 'Vida Failed' },
    1012: { key: 'system', action: 'Data not found' },
    44001: { key: 'limit_usage', action: 'Daily limit usage privy' }
  };

  const mappedError = errorMap[channelCode];

  if (mappedError) {
    dispatch(setError(mappedError.key));
    SendEventDisbursement({
      action: mappedError.action,
      isSecondApply: getState().loanApply.isSecondApply
    });
    sendException({ desc: mappedError.action, fatal: 'true' });
    return;
  }

  dispatch(setError('system'));
};
